import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const primary = [
  { to: '/', icon: '🏠', label: 'Accueil', end: true },
  { to: '/taches', icon: '✅', label: 'Tâches' },
  { to: '/courses', icon: '🛒', label: 'Courses' },
  { to: '/agenda', icon: '📅', label: 'Agenda' },
];

const secondary = [
  { to: '/maison', icon: '🏡', label: 'Maison' },
  { to: '/repas', icon: '🍽️', label: 'Repas' },
  { to: '/emails', icon: '📧', label: 'Emails' },
  { to: '/anniversaires', icon: '🎂', label: 'Anniversaires' },
  { to: '/memoire', icon: '🧠', label: 'Mémoire' },
  { to: '/documents', icon: '📁', label: 'Documents' },
  { to: '/ia', icon: '✨', label: 'IA' },
  { to: '/aide', icon: '❓', label: 'Aide' },
  { to: '/parametres', icon: '⚙️', label: 'Réglages' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goTo = (to) => { setOpen(false); navigate(to); };

  return (
    <>
      {open && (
        <div onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 299, background: 'rgba(0,0,0,0.35)' }}>
          <div onClick={e => e.stopPropagation()}
            style={{ position: 'absolute', bottom: 'var(--nav-height)', left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, background: 'var(--card)', borderRadius: '20px 20px 0 0', padding: '16px 12px 8px', boxShadow: '0 -8px 32px rgba(0,0,0,0.15)' }}>
            <div style={{ width: 36, height: 4, background: '#D0D4E8', borderRadius: 99, margin: '0 auto 16px' }} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
              {secondary.map(({ to, icon, label }) => (
                <button key={to} onClick={() => goTo(to)}
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, padding: '12px 4px', border: 'none', background: '#F0F2FF', borderRadius: 14, cursor: 'pointer', color: '#555577' }}>
                  <span style={{ fontSize: 24 }}>{icon}</span>
                  <span style={{ fontSize: 11, fontWeight: 600 }}>{label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      <nav className="bottom-nav">
        {primary.map(({ to, icon, label, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <span className="nav-icon">{icon}</span>
            <span>{label}</span>
          </NavLink>
        ))}
        <button className="nav-item" onClick={() => setOpen(!open)} style={{ color: open ? 'var(--primary)' : 'var(--text3)' }}>
          <span className="nav-icon">···</span>
          <span>Plus</span>
        </button>
      </nav>
    </>
  );
}
